// removed by extract-text-webpack-plugin
module.exports = {"generic_information_wrapper":"_2TMPOK_vykcO7eYFCxTcOl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/GenericInformationModal/GenericInformationModalComponent.css
// module id = 587
// module chunks = 0